import createModuleLogger from "../../infra/logger/createModuleLogger";
const localizationLogger = createModuleLogger("localization");
export default localizationLogger;
